import React, { useState, useEffect, useRef } from "react";
import {
  User,
  Calendar,
  FileText,
  Activity,
  Heart,
  AlertTriangle,
  Phone,
  Shield,
  Plus,
  Search,
  ChevronRight,
  Stethoscope,
  Clock,
  FilePlus,
  X,
  CheckCircle,
  Pill,
  Thermometer,
  Droplet,
  Wind,
  Award,
  MapPin,
  Mail,
  Clipboard,
  ArrowUpRight,
} from "lucide-react";
import { LayoutMain } from "../LayoutMain";
import { SelectPicker } from "rsuite";
import { notification } from "antd";
import {
  getExpedPaciente,
  getListaPacientes,
} from "../Services/PacientesServices";
import moment from "moment/moment";
import "moment/locale/es"; // Import Spanish locale

moment.locale("es");

export const Expediente = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [patients, setPatients] = useState([]);
  const [dataPaciente, setDataPaciente] = useState();
  const [consultas, setConsultas] = useState([]);
  const [notasEvol, setNotasEvol] = useState([]);
  const [dataSignos, setDataSignos] = useState({
    ta: "",
    fc: "",
    temp: "",
    peso: "",
    estatura: "",
    spo2: "",
  });
  const [dataAnteced, setDataAnteced] = useState([]);

  const [listaPacientes, setListaPacientes] = useState([
    { label: "+ NUEVO PACIENTE", value: "-1" },
  ]);
  const [activeTab, setActiveTab] = useState("history"); // 'history' | 'consultations' | 'evolution'
  const [searchTerm, setSearchTerm] = useState("");

  // CONSTANTES DE PACIENTE
  const [idPaciente, setIdPaciente] = useState(0);
  const [contacto, setContacto] = useState("");
  const [telContacto, setTelContacto] = useState("");
  const [parentesco, setParentesco] = useState("");

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("evolution"); // 'evolution' or 'consultation'

  // New entry form state
  const [formDate, setFormDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [formDoctor, setFormDoctor] = useState("Dra. Sofía Morales");
  const [formReason, setFormReason] = useState("");
  const [formDiagnosis, setFormDiagnosis] = useState("");
  const [formTreatment, setFormTreatment] = useState("");
  const [formEvolution, setFormEvolution] = useState("");
  const [formVitals, setFormVitals] = useState("PA: 120/80 mmHg | FC: 75 lpm");

  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);

  const [currentPatient, setCurrentPatient] = useState({
    idPaciente: 0,
    nombre: "",
    edad: "",
    fecNac: "",
    direccion: "",
    genero: "",
    correo: "",
    contactoEmergencia: {
      nombre: "",
      telefono: "",
      parentesco: "",
    },
    medico: "",
    especialidad: "",
    estatus: "",
  });

  const [evolutionNotes, setEvolutionNotes] = useState([]);
  const [consulta, setConsulta] = useState({
    idExped: "",
    motivo: "",
    diagnostico: "",
    tratamiento: "",
    inidcaciones: "",
  });

  const filteredPatients = patients.filter(
    (p) =>
      p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.id.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const loadPacientes = async () => {
    await getListaPacientes(idNegocio)
      .then((res) => {
        setListaPacientes((prev) => [...prev, ...res]);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadExpediente = async (e) => {
    setIdPaciente(e);
    await getExpedPaciente(idNegocio, e)
      .then((res) => {
        setCurrentPatient({
          idPaciente: res.paciente.idPaciente,
          nombre: res.paciente.nombre,
          edad: res.paciente.edad,
          genero: res.paciente.genero,
          fecNac: res.paciente.fecNac,
          direccion: res.paciente.direccion,
          correo: res.paciente.correo,
          contactoEmergencia: {
            nombre: res.paciente.contactoEmergencia.nombre,
            telefono: res.paciente.contactoEmergencia.telefono,
            parentesco: res.paciente.contactoEmergencia.parentesco,
          },
          medico: res.paciente.medico,
          especialidad: res.paciente.especialidad,
          estatus: res.paciente.estatus,
        });

        
        if (res.consulta !== null) {
          setConsulta({
            idExped: `EXPED-00${res.consulta.idExped}`,
            fecha: res.consulta.fecha,
            hora: res.consulta.hora,
            motivo: res.consulta.motivo,
            diagnostico: res.consulta.diagnostico,
            tratamiento: res.consulta.tratamiento,
            indicaciones: res.consulta.inidcaciones,
          });
        }else{
          setConsulta({
            idExped: "",
            fecha: "",
            hora: "",
            motivo: "",
            diagnostico: "",
            tratamiento: "",
            indicaciones: "",
          });
        }

        if (res.dataSignos !== undefined) {
          setDataSignos({
            ta: res.signos.ta + " mmHg",
            fc: res.signos.fc + " lpm",
            temp: res.signos.temp + " °C",
            peso: res.signos.peso + " kg",
            estatura: res.signos.estatura + " m",
            spo2: res.signos.spo2 + "%",
          });
        } else {
          setDataSignos({
            ta: "",
            fc: "",
            temp: "",
            peso: "",
            estatura: "",
            spo2: "",
          });
        }

        setDataAnteced(res.antecedentes);

        setConsultas(res.consultas);

        setNotasEvol(res.notas);

      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const formatPhoneNumber = (phoneNumberString) => {
    // Filter out all non-numeric characters
    const cleaned = ("" + phoneNumberString).replace(/\D/g, "");

    // Match the groups of numbers
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})\$/);

    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return null;
  };

  const handleAddNewEntry = (e) => {
    e.preventDefault();
    const updatedPatients = patients.map((pat) => {
      if (pat.id === currentPatient.id) {
        if (modalType === "evolution") {
          const newNote = {
            id: `N-${Date.now()}`,
            date: formDate.split("-").reverse().join("/"),
            time: new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
            doctor: formDoctor,
            evolution: formEvolution,
            vitals: formVitals,
            prescription: formTreatment || "Sin cambios en prescripción.",
          };
          return {
            ...pat,
            evolutionNotes: [newNote, ...pat.evolutionNotes],
          };
        } else {
          const newConsultation = {
            id: `C-${Date.now()}`,
            date: formDate.split("-").reverse().join("/"),
            doctor: formDoctor,
            reason: formReason,
            diagnosis: formDiagnosis,
            treatment: formTreatment,
          };
          return {
            ...pat,
            consultations: [newConsultation, ...pat.consultations],
          };
        }
      }
      return pat;
    });

    setPatients(updatedPatients);
    setIsModalOpen(false);
    // Reset form
    setFormReason("");
    setFormDiagnosis("");
    setFormTreatment("");
    setFormEvolution("");
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadPacientes();
    }
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <div>
      <title>Expediente Médico</title>
      {contextHolder}
      <LayoutMain titleItem={"Expediente"}>
        {/* Top Navbar */}

        {/* Main Container */}
        <div className="flex-1 flex flex-col lg:flex-row  w-full mx-auto p-4 md:p-6 gap-6">
          {/* Left Column: Patient Selector & General Summary */}
          <aside className="w-full lg:w-80 flex flex-col gap-4">
            {/* Patient Selector Card */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
              <h2 className="text-xs font-bold uppercase tracking-wider text-slate-600 mb-3">
                Paciente
              </h2>
              <div className="space-y-2 mb-4">
                <SelectPicker
                  data={listaPacientes}
                  value={idPaciente}
                  block
                  size="sm"
                  placeholder="--SELECCIONA--"
                  onChange={(e) => loadExpediente(e)}
                  popupStyle={{ maxHeight: 200 }}
                />
              </div>
              <div className="space-y-2 mb-4">
                <button
                  // onClick={() => setSelectedPatientId(pat.id)}
                  className={`w-full text-left p-3 rounded-xl transition-all flex items-center justify-between border "bg-sky-50 border-sky-300 shadow-sm text-sky-900 font-medium"`}
                >
                  <div>
                    <p className="text-sm font-semibold">
                      {currentPatient.nombre}
                    </p>
                    <p className="text-xs text-slate-500">
                      {consulta.idExped} • {currentPatient.edad} años
                    </p>
                  </div>
                  <ChevronRight className={`w-4 h-4 text-sky-600`} />
                </button>
              </div>
            </div>

            {/* Patient General Data Summary Card */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-5 overflow-hidden relative">
              <div className="absolute top-0 right-0 w-24 h-24 bg-sky-50 rounded-bl-full -z-0 opacity-50"></div>

              <div className="relative z-10">
                <div className="flex items-center justify-between mb-4">
                  <span className="px-2.5 py-1 bg-emerald-100 text-emerald-800 text-xs font-semibold rounded-full flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                    {currentPatient.estatus}
                  </span>
                  <span className="text-xs font-mono font-medium text-slate-400">
                    {consulta.idExped}
                  </span>
                </div>

                <div className="text-center pb-1 border-b border-slate-100">
                  <div className="w-20 h-20 bg-slate-200 rounded-full mx-auto mb-1 flex items-center justify-center text-slate-700 font-bold text-2xl shadow-inner border-2 border-white">
                    {currentPatient.nombre
                      .split(" ")
                      .map((n) => n[0])
                      .slice(0, 2)
                      .join("")}
                  </div>
                  <h3 className="text-lg font-bold text-slate-900">
                    {currentPatient.nombre}
                  </h3>
                  <p className="text-xs text-slate-500 mt-0.5">
                    {currentPatient.genero}, {currentPatient.edad} años (Nac:{" "}
                    {currentPatient.fecNac})
                  </p>
                </div>

                {/* Quick Medical Tags */}
                {/* <div className="py-4 border-b border-slate-100 space-y-3">
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-slate-500 flex items-center gap-1.5 font-medium">
                      <Droplet className="w-3.5 h-3.5 text-red-500" /> Tipo de
                      Sangre:
                    </span>
                    <span className="font-bold text-slate-900 px-2 py-0.5 bg-red-50 text-red-700 rounded">
                      {currentPatient.bloodType}
                    </span>
                  </div>

                  <div className="flex items-start justify-between text-xs">
                    <span className="text-slate-500 flex items-center gap-1.5 font-medium pt-0.5">
                      <AlertTriangle className="w-3.5 h-3.5 text-amber-500" />{" "}
                      Alergias:
                    </span>
                    <div className="flex flex-wrap gap-1 justify-end max-w-[150px]">
                      {currentPatient.allergies.map((alg, idx) => (
                        <span
                          key={idx}
                          className="px-1.5 py-0.5 bg-amber-50 text-amber-800 rounded font-medium text-[11px]"
                        >
                          {alg}
                        </span>
                      ))}
                    </div>
                  </div>

                </div> */}

                {/* Contact Information */}
                <div className="py-4 border-b border-slate-100 space-y-2.5 text-xs">
                  <div className="flex items-center gap-2 text-slate-600">
                    <Phone className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                    <span className="truncate">{currentPatient.telefono}</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-600">
                    <Mail className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                    <span className="truncate">{currentPatient.correo}</span>
                  </div>
                  <div className="flex items-start gap-2 text-slate-600">
                    <MapPin className="w-3.5 h-3.5 text-slate-400 shrink-0 mt-0.5" />
                    <span className="leading-tight">
                      {currentPatient.direccion}
                    </span>
                  </div>
                </div>

                {/* Emergency Contact */}
                <div className="pt-4">
                  <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-2 flex items-center gap-1">
                    <Shield className="w-3 h-3 text-sky-600" /> Contacto de
                    Emergencia
                  </p>
                  <div className="bg-sky-50/60 p-3 rounded-xl border border-sky-100 text-xs">
                    <p className="font-semibold text-slate-900">
                      {`${currentPatient.contactoEmergencia.nombre} (${currentPatient.contactoEmergencia.parentesco})`}
                    </p>
                    <p className="text-sky-700 font-medium mt-0.5">
                      {currentPatient.contactoEmergencia.telefono}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </aside>

          {/* Right Column: Detailed Record & Navigation Tabs */}
          <main className="flex-1 flex flex-col gap-4">
            {/* Header Action Bar */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div>
                <span className="text-xs font-semibold uppercase tracking-wider text-sky-600 block mb-1">
                  Expediente Activo
                </span>
                <h2 className="text-xl font-bold text-slate-900">
                  {currentPatient.nombre}
                </h2>
                <p className="text-xs text-slate-500 mt-0.5">
                  Médico Tratante:{" "}
                  <span className="font-medium text-slate-700">
                    {currentPatient.medico}
                  </span>
                </p>
              </div>

              <div className="flex items-center gap-2.5 w-full sm:w-auto">
                {/* <button
                  onClick={() => {
                    setModalType("consultation");
                    setIsModalOpen(true);
                  }}
                  className="flex-1 sm:flex-none px-4 py-2.5 bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 text-sm font-semibold rounded-xl transition-all shadow-sm flex items-center justify-center gap-2"
                >
                  <FilePlus className="w-4 h-4 text-sky-600" /> Nueva Consulta
                </button>
                <button
                  onClick={() => {
                    setModalType("evolution");
                    setIsModalOpen(true);
                  }}
                  className="flex-1 sm:flex-none px-4 py-2.5 bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold rounded-xl transition-all shadow-md shadow-sky-200 flex items-center justify-center gap-2"
                >
                  <Plus className="w-4 h-4" /> Nota de Evolución
                </button> */}
              </div>
            </div>

            {/* Navigation Tabs */}
            <div className="flex border-b border-slate-200 bg-white rounded-t-2xl px-4 pt-3 shadow-sm">
              <button
                onClick={() => setActiveTab("history")}
                className={`pb-3 px-5 text-sm font-semibold transition-all border-b-2 flex items-center gap-2 ${
                  activeTab === "history"
                    ? "border-sky-600 text-sky-600"
                    : "border-transparent text-slate-500 hover:text-slate-800"
                }`}
              >
                <FileText className="w-4 h-4" /> Historia Clínica
              </button>
              <button
                onClick={() => setActiveTab("consultations")}
                className={`pb-3 px-5 text-sm font-semibold transition-all border-b-2 flex items-center gap-2 ${
                  activeTab === "consultations"
                    ? "border-sky-600 text-sky-600"
                    : "border-transparent text-slate-500 hover:text-slate-800"
                }`}
              >
                <Stethoscope className="w-4 h-4" /> Consultas Previas (
                {consultas.length})
              </button>
              <button
                onClick={() => setActiveTab("evolution")}
                className={`pb-3 px-5 text-sm font-semibold transition-all border-b-2 flex items-center gap-2 ${
                  activeTab === "evolution"
                    ? "border-sky-600 text-sky-600"
                    : "border-transparent text-slate-500 hover:text-slate-800"
                }`}
              >
                <Activity className="w-4 h-4" /> Notas de Evolución (
                {notasEvol.length})
              </button>
            </div>

            {/* Tab Content Area */}
            <div className="bg-white rounded-b-2xl rounded-tr-2xl shadow-sm border border-slate-200 p-6 flex-1">
              {/* TAB 1: HISTORIA CLÍNICA */}
              {activeTab === "history" && (
                <div className="space-y-6 animate-fadeIn">
                  <div className="flex items-center justify-between pb-4 border-b border-slate-100">
                    <div>
                      <h3 className="text-base font-bold text-slate-900">
                        Expediente y Antecedentes Clínicos
                      </h3>
                      <p className="text-xs text-slate-500">
                        Información médica general y última evaluación de signos
                        vitales.
                      </p>
                    </div>
                    <span className="text-xs bg-sky-50 text-sky-700 px-3 py-1 rounded-lg font-medium">
                      Actualizado {moment(consulta.fecha).format("DD-MMM-YYYY")}
                    </span>
                  </div>

                  {/* Vital Signs Grid */}
                  <div>
                    <h4 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3 flex items-center gap-1.5">
                      <Thermometer className="w-4 h-4 text-sky-600" /> Signos
                      Vitales Recientes
                    </h4>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
                      <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200 text-center">
                        <span className="block text-[11px] text-slate-500 font-medium">
                          Presión Arterial
                        </span>
                        <span className="block text-sm font-bold text-slate-900 mt-1">
                          {dataSignos.ta}
                        </span>
                      </div>
                      <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200 text-center">
                        <span className="block text-[11px] text-slate-500 font-medium">
                          Frecuencia Cardíaca
                        </span>
                        <span className="block text-sm font-bold text-slate-900 mt-1">
                          {dataSignos.fc}
                        </span>
                      </div>
                      <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200 text-center">
                        <span className="block text-[11px] text-slate-500 font-medium">
                          Temperatura
                        </span>
                        <span className="block text-sm font-bold text-slate-900 mt-1">
                          {dataSignos.temp}
                        </span>
                      </div>
                      <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200 text-center">
                        <span className="block text-[11px] text-slate-500 font-medium">
                          Peso
                        </span>
                        <span className="block text-sm font-bold text-slate-900 mt-1">
                          {dataSignos.peso}
                        </span>
                      </div>
                      <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200 text-center">
                        <span className="block text-[11px] text-slate-500 font-medium">
                          Estatura
                        </span>
                        <span className="block text-sm font-bold text-slate-900 mt-1">
                          {dataSignos.estatura}
                        </span>
                      </div>
                      <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200 text-center">
                        <span className="block text-[11px] text-slate-500 font-medium">
                          SpO2
                        </span>
                        <span className="block text-sm font-bold text-slate-900 mt-1">
                          {dataSignos.spo2}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Clinical Background Sections */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-2">
                    {dataAnteced.map((seccion, index) => (
                      <div className="bg-slate-50/70 p-4 rounded-xl border border-slate-200">
                        {/* Título e Ícono de la sección */}
                        <h5 className="text-xs font-bold uppercase tracking-wider text-sky-700 mb-2 flex items-center gap-1.5">
                          <Heart
                            className="w-3.5 h-3.5"
                            key={`icono-${index}`}
                          />{" "}
                          {seccion.nombre}
                        </h5>

                        {/*  2. SEGUNDO MAP: Recorre el array interno 'respuestas' */}
                        <div className="space-y-1">
                          {
                            seccion.detalles
                              .filter((d) => d.valorado === "SI")
                              .map((item) => item.Item + " " + item.observacion)
                              .join(", ")
                          }
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* TAB 2: CONSULTAS */}
              {activeTab === "consultations" && (
                <div className="space-y-4 animate-fadeIn">
                  <div className="flex items-center justify-between pb-4 border-b border-slate-100">
                    <div>
                      <h3 className="text-base font-bold text-slate-900">
                        Historial de Consultas Médicas
                      </h3>
                      <p className="text-xs text-slate-500">
                        Registro histórico de valoraciones, diagnósticos y
                        tratamientos iniciales.
                      </p>
                    </div>
                    {/* <button
                      onClick={() => {
                        setModalType("consultation");
                        setIsModalOpen(true);
                      }}
                      className="text-xs bg-sky-50 text-sky-700 font-semibold px-3 py-1.5 rounded-lg hover:bg-sky-100 transition-all flex items-center gap-1"
                    >
                      <Plus className="w-3.5 h-3.5" /> Agregar Consulta
                    </button> */}
                  </div>

                  <div className="space-y-4">
                    {consultas.map((consult, index) => (
                      <div
                        key={index}
                        className="bg-slate-50/80 rounded-xl p-5 border border-slate-200 hover:border-sky-300 transition-all"
                      >
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 pb-3 border-b border-slate-200">
                          <div className="flex items-center gap-2">
                            <span className="px-2.5 py-1 bg-sky-100 text-sky-800 text-xs font-bold rounded-md">
                              {moment(consult.fecha).format("DD-MMM-YYYY")}
                            </span>
                            <span className="text-sm font-bold text-slate-900">
                              {consult.medico}
                            </span>
                          </div>
                          <span className="text-xs font-mono text-slate-400">
                            {`C-00${consult.idCons}`}
                          </span>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-3 text-sm">
                          <div>
                            <span className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1">
                              Motivo de Consulta
                            </span>
                            <p className="text-slate-700">{consult.motivo}</p>
                          </div>
                          <div>
                            <span className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1">
                              Diagnóstico Médico
                            </span>
                            <p className="font-medium text-slate-900">
                              {consult.diagnostico}
                            </p>
                          </div>
                          <div>
                            <span className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1">
                              Indicaciones
                            </span>
                            <p className="text-slate-700 bg-white p-2.5 rounded-lg border border-slate-200 text-xs flex items-start gap-1.5">
                              <Pill className="w-3.5 h-3.5 text-sky-600 shrink-0 mt-0.5" />
                              <span>{consult.indicaciones}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* TAB 3: NOTAS DE EVOLUCIÓN */}
              {activeTab === "evolution" && (
                <div className="space-y-4 animate-fadeIn">
                  <div className="flex items-center justify-between pb-4 border-b border-slate-100">
                    <div>
                      <h3 className="text-base font-bold text-slate-900">
                        Notas de Evolución y Seguimiento
                      </h3>
                      <p className="text-xs text-slate-500">
                        Notas periódicas del estado del paciente, signos vitales
                        y control de medicamentos.
                      </p>
                    </div>
                    {/* <button
                      onClick={() => {
                        setModalType("evolution");
                        setIsModalOpen(true);
                      }}
                      className="text-xs bg-sky-600 text-white font-semibold px-3.5 py-1.5 rounded-lg hover:bg-sky-700 transition-all flex items-center gap-1 shadow-sm"
                    >
                      <Plus className="w-3.5 h-3.5" /> Nueva Nota
                    </button> */}
                  </div>

                  <div className="space-y-4">
                    {notasEvol.map((note, index) => (
                      <div
                        key={index}
                        className="bg-white rounded-xl p-5 border border-slate-200 shadow-sm relative overflow-hidden"
                      >
                        <div className="absolute top-0 left-0 w-1.5 h-full bg-sky-500"></div>

                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 pb-3 border-b border-slate-100">
                          <div className="flex items-center gap-2.5">
                            <div className="bg-sky-50 text-sky-700 px-3 py-1 rounded-lg text-xs font-bold flex items-center gap-1">
                              <Calendar className="w-3.5 h-3.5" /> {note.fecha}
                            </div>
                            <div className="text-xs text-slate-500 flex items-center gap-1">
                              <Clock className="w-3.5 h-3.5" /> {note.hora}
                            </div>
                          </div>
                          <span className="text-xs font-medium text-slate-600">
                            {note.medico}
                          </span>
                        </div>

                        <div className="py-3 space-y-3">
                          <div>
                            <span className="block text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-1">
                              Evolución Clínica
                            </span>
                            <p className="text-sm text-slate-800 leading-relaxed">
                              {note.nota}
                            </p>
                          </div>

                          <div className="flex flex-wrap items-center gap-3 pt-1">
                            <div className="bg-slate-50 px-3 py-1.5 rounded-lg border border-slate-200 text-xs font-medium text-slate-700 flex items-center gap-1.5">
                              <Activity className="w-3.5 h-3.5 text-sky-600" />
                              <span>{`${note.datosExplora.PresionArterial} mmHg | FC: ${note.datosExplora.FrecCardiaca} Ipm | SpO2: ${note.datosExplora.SaturaOx}`}</span>
                            </div>
                          </div>

                          <div className="bg-sky-50/50 p-3 rounded-lg border border-sky-100 text-xs text-sky-900 flex items-start gap-2">
                            <Pill className="w-4 h-4 text-sky-600 shrink-0 mt-0.5" />
                            <div>
                              <span className="font-semibold block mb-0.5">
                                Prescripción / Indicaciones:
                              </span>
                              {note.indicaciones}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </main>
        </div>

        {/* Interactive Modal for New Consultation or Evolution Note */}
        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fadeIn">
            <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]">
              {/* Modal Header */}
              <div className="px-6 py-4 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="p-2 bg-sky-100 text-sky-700 rounded-lg">
                    {modalType === "evolution" ? (
                      <Activity className="w-5 h-5" />
                    ) : (
                      <Stethoscope className="w-5 h-5" />
                    )}
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-slate-900">
                      {modalType === "evolution"
                        ? "Nueva Nota de Evolución"
                        : "Registrar Nueva Consulta"}
                    </h3>
                    <p className="text-xs text-slate-500">
                      Paciente: {currentPatient.name}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="text-slate-400 hover:text-slate-600 p-1 rounded-lg hover:bg-slate-200/60 transition-all"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {/* Modal Body / Form */}
              <form
                onSubmit={handleAddNewEntry}
                className="p-6 overflow-y-auto space-y-4 flex-1"
              >
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-slate-700 mb-1">
                      Fecha
                    </label>
                    <input
                      type="date"
                      value={formDate}
                      onChange={(e) => setFormDate(e.target.value)}
                      className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-slate-700 mb-1">
                      Médico Responsable
                    </label>
                    <input
                      type="text"
                      value={formDoctor}
                      onChange={(e) => setFormDoctor(e.target.value)}
                      className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500"
                      required
                    />
                  </div>
                </div>

                {modalType === "consultation" ? (
                  <>
                    <div>
                      <label className="block text-xs font-semibold text-slate-700 mb-1">
                        Motivo de Consulta
                      </label>
                      <textarea
                        rows="2"
                        value={formReason}
                        onChange={(e) => setFormReason(e.target.value)}
                        placeholder="Describa el motivo principal de la visita..."
                        className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500 resize-none"
                        required
                      ></textarea>
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-slate-700 mb-1">
                        Diagnóstico
                      </label>
                      <input
                        type="text"
                        value={formDiagnosis}
                        onChange={(e) => setFormDiagnosis(e.target.value)}
                        placeholder="Diagnóstico clínico principal..."
                        className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-slate-700 mb-1">
                        Tratamiento / Plan
                      </label>
                      <textarea
                        rows="3"
                        value={formTreatment}
                        onChange={(e) => setFormTreatment(e.target.value)}
                        placeholder="Medicamentos recetados e indicaciones..."
                        className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500 resize-none"
                        required
                      ></textarea>
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <label className="block text-xs font-semibold text-slate-700 mb-1">
                        Signos Vitales y Parámetros
                      </label>
                      <input
                        type="text"
                        value={formVitals}
                        onChange={(e) => setFormVitals(e.target.value)}
                        placeholder="Ej. PA: 120/80 | FC: 72 lpm"
                        className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-slate-700 mb-1">
                        Evolución Clínica
                      </label>
                      <textarea
                        rows="3"
                        value={formEvolution}
                        onChange={(e) => setFormEvolution(e.target.value)}
                        placeholder="Descripción detallada de la evolución del paciente..."
                        className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500 resize-none"
                        required
                      ></textarea>
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-slate-700 mb-1">
                        Prescripción o Cambios Terapéuticos
                      </label>
                      <textarea
                        rows="2"
                        value={formTreatment}
                        onChange={(e) => setFormTreatment(e.target.value)}
                        placeholder="Ajustes de medicamentos o indicaciones..."
                        className="w-full px-3 py-2 text-sm bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500 resize-none"
                        required
                      ></textarea>
                    </div>
                  </>
                )}

                <div className="pt-4 flex items-center justify-end gap-3 border-t border-slate-200">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="px-4 py-2 border border-slate-300 hover:bg-slate-100 text-slate-700 text-sm font-semibold rounded-xl transition-all"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="px-5 py-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold rounded-xl shadow-md shadow-sky-200 transition-all flex items-center gap-2"
                  >
                    <CheckCircle className="w-4 h-4" /> Guardar Registro
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </LayoutMain>
    </div>
  );
};
